module.exports = __webpack_public_path__ + "static/media/m25a_thumb_even.1834869b.jpg";